module.exports = __webpack_public_path__ + "img/コンピュータのしくみI_4_19_1.f0ae3fa4.jpeg";